import React from "react";

import "animate.css";
import { Rate } from "antd";
import { useRouter } from "next/router";
import { Carousel } from "react-bootstrap";

import styles from "./HeaderSliderComponent.module.css";
import { formatToCurrency } from "../../../helper/service";

const HeaderSliderComponent = (props) => {
  const {
    bandCost,
    totalPieces,
    data: { name, reviewRatings, numberOfReviews, images, pieces },
  } = props;

  const router = useRouter();

  return (
    <section className={styles.band_slider_container}>
      <div className={styles.header_shadow_right}></div>
      <div className={styles.header_shadow_left}></div>

      <div className={styles.band_slider_overlay}></div>
      {images !== undefined && (
        <Carousel indicators={true}>
          {images.map(({ path }, idx) => (
            <Carousel.Item key={idx}>
              <img
                className="d-block w-100"
                style={{}}
                src={process.env.IMAGE_LINK + path}
                alt="First slide"
              />
            </Carousel.Item>
          ))}
        </Carousel>
      )}
      <div className={`carousel-caption ${styles.carousel_full_text}`}>
        <h1 onClick={() => router.back()} className={styles.band_slide_title}>
          {name}
        </h1>
        {numberOfReviews > 0 && (
          <div
            className={`d-flex align-items-center mb-2 ${styles.search_result_card_rating}`}
          >
            <Rate
              allowHalf
              value={reviewRatings}
              disabled
              className={styles.search_result_card_rating_star}
            />
            <p className={styles.search_result_card_rating_reviews}>
              {numberOfReviews} reviews
            </p>
          </div>
        )}
        {pieces > 0 && bandCost > 0 && (
          <>
            <p className={styles.band_slide_price_info}>
              {`Average Price for ${
                totalPieces !== 0 ? totalPieces : pieces ?? 0
              } Pieces*`}
            </p>
            <span className={styles.band_slide_price}>
              ${formatToCurrency(bandCost)}
            </span>
          </>
        )}
      </div>
      <div className={styles.band_slider_shadow}></div>
      <a
        className={`scroll_down ${styles.band_scroll_down}`}
        onClick={() => window.scrollTo(0, props.navRef.current.offsetTop - 120)}
      >
        <div
          className="animate__animated
                          animate__fadeInDown
                          animate__delay-2s
                          animate__duration-1.2s"
        >
          <div className="scroll_down_object">
            {" "}
            <span></span>{" "}
          </div>
        </div>
        <div
          className="animate__animated
                          animate__fadeInUp
                          animate__delay-2.2s
                          animate__duration-1.2s"
        >
          <h6 className={`scroll_down_title ${styles.scroll_down_title}`}>
            Scroll Down
          </h6>
        </div>
        <div
          className="animate__animated
                          animate__fadeInUp
                          animate__delay-2.4s
                          animate__duration-1.2s"
        >
          <p className={`scroll_down_text ${styles.scroll_down_text}`}>
            to discover more
          </p>
        </div>
      </a>
      <div className={styles.header_shadow_bottom}></div>
    </section>
  );
};

export default HeaderSliderComponent;
